import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        // 轮播图
        bannerData: [
            "static/image/banner1.jpg",
            "static/image/banner2.png",
            "static/image/banner3.png",
            "static/image/banner4.png"
        ],

       
        //新闻列表
        newsList: [{
                newsType: "[公告]",
                newsTittle: "美德少年发布2.0版本",
                newsDate: "[2021/7/29]"
            },
            {
                newsType: "[公告]",
                newsTittle: "美德少年发布1.9版本",
                newsDate: "[2021/6/26]"
            },
            {
                newsType: "[公告]",
                newsTittle: "美德少年发布1.8版本",
                newsDate: "[2021/6/15]"
            },
            {
                newsType: "[公告]",
                newsTittle: "美德少年发布1.7版本",
                newsDate: "[2021/6/4]"
            },
            {
                newsType: "[公告]",
                newsTittle: "美德少年发布1.5版本",
                newsDate: "[2021/5/16]"
            },
            {
                newsType: "[公告]",
                newsTittle: "美德少年发布1.0版本",
                newsDate: "[2021/3/20]"
            },
        ],


    },


    mutations: {
        increment(state) {
            state.count++
        }
    }
})

export default store;


// WEBPACK FOOTER //
// ./src/vuex/store.js